<div class="content-wrapper">


  <!-- Main content -->
  <section class="content">
    <div class="container-fluid" style="padding: 20px 0">
      <!-- Info boxes -->
      <router-outlet></router-outlet>
      <!-- /.row -->

    </div><!--/. container-fluid -->
  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->
